import script from "./TooltipComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipComponent.vue?vue&type=script&setup=true&lang=js"

import "./TooltipComponent.vue?vue&type=style&index=0&id=1b53ab6e&lang=scss"

const __exports__ = script;

export default __exports__